<template>
  <div id="app">
    <fccBaseLayout v-if="!$route.meta.hidefccBase">
      <router-view></router-view>
    </fccBaseLayout>
    <router-view v-if="$route.meta.hidefccBase"></router-view>
  </div>
</template>

<script>
import fccBaseLayout from 'pkgfe.fccbase/baseLayout/fccBase.vue'

export default {
  name: 'App',
  data: () => ({
    expand: ''
  }),
  components: {
    fccBaseLayout
  }
}
</script>
